import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'app-conference-page',
  templateUrl: './conference-page.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ConferencePageComponent implements OnInit {
  @Input() $transition$: any;

  stateParams: any;
  candidateId: any;
  jobId: any;
  jobMatchId: any;
  scheduleId: any;
  type: any;
  mode: any;
  workflowStep: any;
  isLoaded: boolean;

  constructor(private utilityService: UtilityService) { }

  ngOnInit() {
    this.stateParams = this.$transition$.params();
    this.isLoaded = false;
    this.candidateId = this.stateParams.c;
    this.jobId = this.stateParams.j;
    this.jobMatchId = this.stateParams.jm;
    this.scheduleId = this.stateParams.sh;
    this.type = "u";
    // this.type = this.stateParams.t;
    this.mode = this.stateParams.mode;
    this.workflowStep = this.stateParams.ws;
    this.utilityService.toggleHeaderNavDisplay(false);
    setTimeout(() => {
      this.isLoaded = true;
    }, 4000);
  }
}
